<template>
  <v-dialog v-model="visible" max-width="1200px" scrollable>
    <v-form>
      <v-card style="overflow-y: hidden">
        <v-card-title class="py-2 px-4">{{ nombreItem }}</v-card-title>

        <v-divider class="my-0"></v-divider>

        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" lg="8">
              <v-row>
                <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="6" class="pa-0">
                  <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
                </v-col>

                <v-col cols="12" v-if="!item.carpetaAcademicaArchivoId">
                  <v-row dense class="mb-2">
                    <v-col cols="12" sm="6">
                      <v-menu
                        v-model="menuFechaRecepcion"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechaRecepcion"
                            label="Fecha de Recepción *"
                            prepend-inner-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            clearable
                            hide-details
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fechaRecepcion"
                          no-title
                          scrollable
                          @input="menuFechaRecepcion = false"></v-date-picker>
                      </v-menu>
                      <small v-for="error in errores.fechaRecepcion" :key="error" class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-menu
                        v-model="menuFechaCargadoNotasUnsxx"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechaCargadoNotasUnsxx"
                            label="Fecha Cargado Notas UNSXX *"
                            prepend-inner-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            clearable
                            hide-details
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fechaCargadoNotasUnsxx"
                          no-title
                          scrollable
                          @input="menuFechaCargadoNotasUnsxx = false"></v-date-picker>
                      </v-menu>
                      <small v-for="error in errores.fechaCargadoNotasUnsxx" :key="error" class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="citeUnsxx"
                        label="Cite UNSXX *"
                        maxlength="255"
                        counter="255"
                        outlined
                        dense
                        hide-details></v-text-field>
                      <small v-for="error in errores.citeUnsxx" :key="error" class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-menu
                        v-model="menuFechaCiteUnsxx"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechaCiteUnsxx"
                            label="Fecha de Cite UNSXX *"
                            prepend-inner-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            clearable
                            hide-details
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fechaCiteUnsxx"
                          no-title
                          scrollable
                          @input="menuFechaCiteUnsxx = false"></v-date-picker>
                      </v-menu>
                      <small v-for="error in errores.fechaCiteUnsxx" :key="error" class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>
                  </v-row>

                  <v-file-input
                    v-model="archivo"
                    class="file-input"
                    label="Adjuntar Carpeta Académica (PDF)"
                    accept="application/pdf"
                    :prepend-icon="''"
                    prepend-inner-icon="mdi-paperclip"
                    outlined
                    dense
                    clearable
                    hide-details
                    @change="onFileChange"></v-file-input>

                  <small class="d-block text-muted"> Formato permitido: PDF </small>

                  <small v-for="error in errores.archivoBase64" :key="error" class="d-block text-danger">
                    {{ error }}
                  </small>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" lg="4">
              <div class="d-flex justify-center align-center contenedor-previsualizacion">
                <v-progress-circular
                  v-if="cargandoCarpetaAcademica"
                  indeterminate
                  color="primary"
                  size="50"></v-progress-circular>

                <template v-if="!cargandoCarpetaAcademica">
                  <template v-if="previsualizacion">
                    <iframe :src="previsualizacion" height="400px"></iframe>
                    <v-btn
                      v-if="item.carpetaAcademicaArchivoId"
                      style="position: absolute; bottom: 15px; right: 15px; z-index: 1"
                      color="primary"
                      small
                      @click.prevent="
                        descargarArchivo(previsualizacion, `CarpetaAcademica_${item.codigo}_${item.programaNombre}`)
                      ">
                      <v-icon>mdi-download</v-icon>

                      Descargar
                    </v-btn>
                  </template>

                  <v-icon v-else>mdi-image-broken-variant</v-icon>
                </template>
              </div>
            </v-col>

            <v-col cols="12">
              <TablaCantidadInscritosPrograma ref="tablaCantidadInscritosRef" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-0"></v-divider>

        <v-card-actions>
          <v-btn
            v-if="!item.carpetaAcademicaArchivoId"
            color="primary"
            text
            :disabled="enviando"
            :loading="enviando"
            @click.prevent="$refs.confirmacionRef.abrir()">
            <v-icon left>mdi-content-save</v-icon>

            Guardar
          </v-btn>

          <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />
  </v-dialog>
</template>

<script>
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';
import { concatenar, formatearFechaCadena } from '../utils/funciones';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';
import TablaCantidadInscritosPrograma from '../components/TablaCantidadInscritosPrograma.vue';

export default {
  name: 'ModalFormAgregarCarpetaAcademica',
  mixins: [programaUniversidadMixin],
  components: {
    ConfirmacionAccion,
    TablaCantidadInscritosPrograma,
  },
  watch: {
    archivoBase64: function () {
      this.errores.archivoBase64 = [];
    },
    fechaRecepcion() {
      this.errores.fechaRecepcion = [];
    },
    fechaCargadoNotasUnsxx() {
      this.errores.fechaCargadoNotasUnsxx = [];
    },
    citeUnsxx() {
      this.errores.citeUnsxx = [];
    },
    fechaCiteUnsxx() {
      this.errores.fechaCiteUnsxx = [];
    },
  },
  computed: {
    listado() {
      const items = [
        { nombre: 'Código', valor: this.item.codigo },
        { nombre: 'Nombre Programa', valor: this.item.programaNombre },
        { nombre: 'Área', valor: this.item.areaUniversidad?.nombre },
        { nombre: 'Tipo', valor: this.item.categoriaUniversidad?.nombre },
        {
          nombre: 'Gestión / Versión / Grupo',
          valor: `${this.item.gestion} / ${this.item.version} / ${this.item.grupo || '-'}`,
        },
        { nombre: 'Sede Universidad', valor: this.item.sedeUniversidad?.nombre },
        { nombre: 'Estado', valor: this.item.estado?.toUpperCase() },
      ];

      if (this.item.carpetaAcademicaArchivoId) {
        items.push(
          { nombre: 'Fecha de Recepción', valor: formatearFechaCadena(this.item.fechaRecepcion) || '-' },
          {
            nombre: 'Fecha Cargado Notas UNSXX',
            valor: formatearFechaCadena(this.item.fechaCargadoNotasUnsxx) || '-',
          },
          { nombre: 'Cite UNSXX', valor: this.item.citeUnsxx ?? '-' },
          { nombre: 'Fecha de Cite UNSXX', valor: formatearFechaCadena(this.item.fechaCiteUnsxx) || '-' },
          { nombre: 'Subido por', valor: this.item.carpetaAcademicaSubidoPorNombre || '-' },
        );
      }

      return items;
    },
  },
  data() {
    return {
      visible: false,
      item: this.generarObjetoFormRegistrar(),
      nombreItem: 'Carpeta Académica',
      archivo: null,
      archivoBase64: null,
      fechaRecepcion: null,
      fechaCargadoNotasUnsxx: null,
      citeUnsxx: null,
      fechaCiteUnsxx: null,
      menuFechaRecepcion: false,
      menuFechaCargadoNotasUnsxx: false,
      menuFechaCiteUnsxx: false,
      previsualizacion: null,
      cargandoCarpetaAcademica: false,
      confirmacion: {
        titulo: 'Subir Carpeta Académica',
        mensaje: '¿Está seguro que desea subir la carpeta académica? Esta acción no se puede deshacer.',
        realizandoAccion: false,
        fnAceptar: () => this.guardar(),
      },
    };
  },
  methods: {
    abrir(data = null) {
      this.archivo = null;
      this.archivoBase64 = null;
      this.fechaRecepcion = null;
      this.fechaCargadoNotasUnsxx = null;
      this.citeUnsxx = null;
      this.fechaCiteUnsxx = null;
      this.menuFechaRecepcion = false;
      this.menuFechaCargadoNotasUnsxx = false;
      this.menuFechaCiteUnsxx = false;
      this.previsualizacion = null;
      this.item = this.generarObjetoFormEditar(data);
      this.visible = true;

      this.$nextTick(() => {
        this.$refs.tablaCantidadInscritosRef.cargar(this.item.id);
      });

      if (this.item.carpetaAcademicaArchivoId) {
        this.cargandoCarpetaAcademica = true;

        ProgramaUniversidadService.obtenerCarpetaAcademica(this.item.id)
          .then((response) => {
            const data = response?.data;
            const datos = data?.datos;

            if (datos) {
              const byteCharacters = atob(datos.file64);
              const byteNumbers = new Array(byteCharacters.length);

              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/pdf' });
              this.previsualizacion = URL.createObjectURL(blob);
            }
          })
          .catch((error) => {
            window.console.log({ error });
            this.previsualizacion = null;
          })
          .finally(() => {
            this.cargandoCarpetaAcademica = false;
          });
      }
    },
    cerrar() {
      this.visible = false;
    },
    onFileChange() {
      if (!this.archivo) {
        this.previsualizacion = null;
        this.archivoBase64 = null;
        return;
      }

      if (this.archivo.type !== 'application/pdf') {
        this.errores.archivoBase64 = ['El archivo debe ser de formato PDF.'];
        this.archivo = null;
        this.previsualizacion = null;
        this.archivoBase64 = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const result = e.target.result;
        this.archivoBase64 = result.split(',')[1];

        const blob = new Blob([this.archivo], { type: 'application/pdf' });
        this.previsualizacion = URL.createObjectURL(blob);
      };

      reader.readAsDataURL(this.archivo);
    },
    async guardar() {
      const erroresLocales = {};
      const esFechaISO = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);

      if (!this.archivoBase64) {
        erroresLocales.archivoBase64 = ['Debe adjuntar el archivo de la carpeta académica.'];
      }
      if (!esFechaISO(this.fechaRecepcion)) {
        erroresLocales.fechaRecepcion = ['Debe seleccionar una fecha válida.'];
      }
      if (!esFechaISO(this.fechaCargadoNotasUnsxx)) {
        erroresLocales.fechaCargadoNotasUnsxx = ['Debe seleccionar una fecha válida.'];
      }
      if (!this.citeUnsxx || !this.citeUnsxx.trim()) {
        erroresLocales.citeUnsxx = ['Debe ingresar el cite UNSXX.'];
      }
      if (!esFechaISO(this.fechaCiteUnsxx)) {
        erroresLocales.fechaCiteUnsxx = ['Debe seleccionar una fecha válida.'];
      }

      if (Object.keys(erroresLocales).length > 0) {
        this.errores = erroresLocales;
        return;
      }

      this.enviando = true;
      this.confirmacion.realizandoAccion = true;

      try {
        const payload = {
          archivoBase64: this.archivoBase64,
          carpetaAcademicaSubidoPorId: Number(this.$store.state.DATA_USER.id),
          carpetaAcademicaSubidoPorNombre: concatenar(
            this.$store.state.DATA_USER.nombres,
            this.$store.state.DATA_USER.pri_apellido,
            this.$store.state.DATA_USER.seg_apellido,
          ),
          fechaRecepcion: this.fechaRecepcion,
          fechaCargadoNotasUnsxx: this.fechaCargadoNotasUnsxx,
          citeUnsxx: this.citeUnsxx,
          fechaCiteUnsxx: this.fechaCiteUnsxx,
        };
        const response = await ProgramaUniversidadService.agregarCarpetaAcademica(this.item.id, payload);
        const data = response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: mensaje || 'Carpeta académica subida con éxito.',
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        window.console.log({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;
        const errores = data?.errores;

        if (errores) {
          this.errores = errores;
        }

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al subir la carpeta académica.',
          type: 'error',
        });
      } finally {
        this.enviando = false;
        this.confirmacion.realizandoAccion = false;
      }
    },
    descargarArchivo(url, nombre) {
      const link = document.createElement('a');
      link.href = url;
      link.download = nombre;
      link.click();
    },
  },
};
</script>

<style scoped>
.contenedor-previsualizacion {
  border: 1px solid #c5c5c5;
  border-radius: 5px;
  padding: 10px;
  height: 420px;
  max-height: 420px;
  background-color: #f5f5f5;
  position: relative;
}

.contenedor-previsualizacion iframe {
  border: none;
  width: 100%;
}
</style>
